<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-if="dataLoaded" style="padding-bottom: 48px;">
      <v-container fluid class="ret-container-above-card">
        <v-layout row wrap>
          <v-flex xs12 md3 class="ret-spaced">
            <v-autocomplete
              clearable
              :items="projects"
              v-model="selectedProjectId"
              :label="$tc('projects.entity-name', 1)">
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 md3 class="ret-spaced">
            <v-autocomplete
              clearable
              :items="users"
              v-model="selectedAssigneeUserId"
              item-value="id"
              item-text="displayName"
              label="Assignee">
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 md3 class="ret-spaced">
            <v-autocomplete
              clearable
              :items="users"
              v-model="selectedReporterUserId"
              item-value="id"
              item-text="displayName"
              label="Reporter">
            </v-autocomplete>
          </v-flex>
          <v-flex class="ret-spaced">
            <v-menu bottom right :min-width="240">
              <template v-slot:activator="{ on }">
                <v-btn text icon v-on="on">
                  <v-icon>filter_list</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="setFilter('')">
                  <v-list-item-avatar>
                    <v-icon>clear</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title>Clear all filters</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setFilter('my-pipe-tasks')">
                  <v-list-item-avatar>
                    <v-icon>assignment_ind</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title>My Tasks</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setFilter('pipe-tasks-reported-by-me')">
                  <v-list-item-avatar>
                    <v-icon>assignment_ind</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title>Reported by me</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn icon @click="postponeOutdatedPipeTasks">
              <v-icon>fast_forward</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>

      <v-card v-if="project.id" class="ret-header-card">
        <v-card-title>
          <v-btn icon @click="selectedProjectId = undefined">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <h1 class="headline">{{ project.code }} <span style="font-weight: 300">{{ project.name }}</span></h1>
          <v-spacer></v-spacer>
          <v-btn icon @click="$router.push({name: `projects/id`, params: {id: project.id}})">
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn color="accent" fab small dark @click="addPipeTask(project.id)">
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="project.info">
          <p style="white-space: pre-wrap;">{{ project.info }}</p>
        </v-card-text>
      </v-card>

      <pipe-task
        v-for="pipeTask in todayPipeTasks" :key="pipeTask.id"
        :item="pipeTask"
        :users="users"
        :projects="projects"
        @updateItem="onUpdatePipeTask"
        @destroyItem="onDestroyPipeTask"
        @updateLinkedItem="onUpdateLinkedItem"
        @destroyLinkedItem="onDestroyLinkedItem"
        @routeToProject="onRouteToProject">
      </pipe-task>

      <div v-if="actionablePipeTasks.length" class="ret-middle-above-card">
        <v-icon>calendar_today</v-icon>
      </div>
      <pipe-task
        v-for="pipeTask in actionablePipeTasks" :key="pipeTask.id"
        :item="pipeTask"
        :users="users"
        :projects="projects"
        @updateItem="onUpdatePipeTask"
        @destroyItem="onDestroyPipeTask"
        @updateLinkedItem="onUpdateLinkedItem"
        @destroyLinkedItem="onDestroyLinkedItem"
        @routeToProject="onRouteToProject">
      </pipe-task>

      <div v-if="donePipeTasks.length" class="ret-middle-above-card">
        <v-icon>done_all</v-icon>
      </div>
      <pipe-task
        v-for="pipeTask in donePipeTasks" :key="pipeTask.id"
        :item="pipeTask"
        :users="users"
        :projects="projects"
        @updateItem="onUpdatePipeTask"
        @destroyItem="onDestroyPipeTask"
        @updateLinkedItem="onUpdateLinkedItem"
        @destroyLinkedItem="onDestroyLinkedItem"
        @routeToProject="onRouteToProject">
      </pipe-task>

    </div>
  </div>
</template>

<style scoped>
  /* div.container.ret-container-above-card h1 {
    margin-left: 0px;
    font-size: 24px;
  }

  div.container.ret-container-above-card p {
    color: rgba(0, 0, 0, 0.54);
  } */

  div.ret-project-brief {
    margin-bottom: 24px;
  }
</style>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import itemsHelpers from '../helpers/items-helpers.es6'
import PipeTask from './components/pipe-task.vue'
import moment from 'moment'

export default {
  mixins: [displayHelpers, itemsHelpers],
  data () {
    return {
      model: {
        name: 'pipe-tasks'
      },
      customParams: {
        actionableOnly: true,
        projectIds: []
      },
      auxModels: [
        { name: 'projects' },
        { name: 'users' }
      ],
      search: '',
      selectedProjectId: undefined,
      selectedAssigneeUserId: undefined,
      selectedReporterUserId: undefined,
      today: moment()
    }
  },
  created () {
    this.setFilter('my-pipe-tasks')
  },
  computed: {
    filteredItems () {
      let result = [...this.items]
      if (this.selectedAssigneeUserId) {
        result = result.filter(item => item.assigneeUserId === this.selectedAssigneeUserId || !item.assigneeUserId)
      }
      if (this.selectedReporterUserId) {
        result = result.filter(item => item.reporterUserId === this.selectedReporterUserId || !item.reporterUserId)
      }
      return result
    },
    todayPipeTasks () {
      return [...this.filteredItems]
        .filter(item => item.actionAt && moment(item.actionAt).isSame(this.today, 'day'))
        .sort((a, b) => {
          // Sort by actionAt
          if (moment(a.actionAt).isAfter(moment(b.actionAt))) return 1
          if (moment(a.actionAt).isSame(moment(b.actionAt))) return 0
          return -1
        })
    },
    actionablePipeTasks () {
      return [...this.filteredItems]
        .filter(item => item.actionAt && !moment(item.actionAt).isSame(this.today, 'day'))
        .sort((a, b) => {
          // Sort by actionAt
          if (moment(a.actionAt).isAfter(moment(b.actionAt))) return 1
          if (moment(a.actionAt).isSame(moment(b.actionAt))) return 0
          return -1
        })
    },
    donePipeTasks () {
      return [...this.filteredItems]
        .filter(item => !item.actionAt)
        .sort((a, b) => {
          // Sort by datum (DESC)
          if (moment(b.datum).isAfter(moment(a.datum))) return 1
          if (moment(b.datum).isSame(moment(a.datum))) return 0
          return -1
        })
    },
    project () {
      return this.selectedProjectId ? this.projects.find(project => project.id === this.selectedProjectId) : {}
    },
    projects () {
      return [...this.$store.state.items.projects]
        .sort((a, b) => {
          return (a.code > b.code) ? 1 : -1
        })
        .map((item) => {
          return Object.assign(item, {
            text: `${item.code} ${item.name}`,
            value: item.id
          })
        })
    },
    users () {
      return this.$store.state.items.users
    },
    loggedUserId () {
      return this.$store.state.auth.currentUser.id
    }
  },
  methods: {
    async addPipeTask (projectId) {
      const newPipeTask = {
        projectId,
        name: '',
        category: 'note',
        actionAt: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        datum: moment().format('YYYY-MM-DD HH:mm:ss'),
        assigneeUserId: this.$store.state.auth.currentUser.id,
        reporterUserId: this.$store.state.auth.currentUser.id
      }
      await this.$store.dispatch('updateItem', { modelName: 'pipe-tasks', item: newPipeTask })
      this.storeUpdate()
    },
    async onUpdatePipeTask (pipeTask) {
      await this.$store.dispatch('updateItem', { modelName: 'pipe-tasks', item: pipeTask })
      this.storeUpdate()
    },
    async onDestroyPipeTask (pipeTask) {
      // TODO: Refactor
      await this.$store.dispatch('destroyItem', { model: { name: 'pipe-tasks' }, id: pipeTask.id })
      this.storeUpdate()
    },
    async onUpdateLinkedItem (pipeTaskInProject) {
      await this.$store.dispatch('updateItem', { modelName: 'pipe-tasks-in-projects', item: pipeTaskInProject })
      this.storeUpdate()
    },
    async onDestroyLinkedItem (pipeTaskInProjectId) {
      await this.$store.dispatch('destroyItem', {
        model: { name: 'pipe-tasks-in-projects' },
        id: pipeTaskInProjectId
      })
      this.storeUpdate()
    },
    onRouteToProject (projectId) {
      this.selectedProjectId = projectId
    },
    setFilter (filterName = 'my-pipe-tasks') {
      if (!filterName) {
        this.selectedProjectId = undefined
        this.selectedAssigneeUserId = undefined
        this.selectedReporterUserId = undefined
      } else if (filterName === 'my-pipe-tasks') {
        this.selectedProjectId = undefined
        this.selectedAssigneeUserId = this.loggedUserId
        this.selectedReporterUserId = undefined
      } else if (filterName === 'pipe-tasks-reported-by-me') {
        this.selectedProjectId = undefined
        this.selectedAssigneeUserId = undefined
        this.selectedReporterUserId = this.loggedUserId
      }
    },
    async postponeOutdatedPipeTasks () {
      await this.$store.dispatch('postponeOutdatedPipeTasks')
      this.storeUpdate()
    }
  },
  watch: {
    selectedProjectId (val) {
      if (val) {
        this.customParams.projectIds = [val]
        this.customParams.actionableOnly = false
      } else {
        this.customParams.projectIds = []
        this.customParams.actionableOnly = true
      }
      this.storeUpdate()
    }
  },
  components: {
    PipeTask
  }
}
</script>
